import { apiClient } from "@base/api/client";

export const fetchUserInfo = async (): Promise<{
  user: {
    id: number;
    name: string;
    first_name: string;
    last_name: string;
    email: string;
    phone_number: string;
    phone_number_country_code: number;
    uuid: string;
    service_due_date: string | null;
    foreign_direct_investment_status: string | null;
    is_email_verified: boolean;
    source: "AUTH_SOURCE_UNSPECIFIED" | "BUILDBLOCK_WEB" | "GOOGLE_OAUTH" | "KAKAO_OAUTH";
    is_agreed_to_ad_term: boolean;
  };
  roles: string[];
}> => {
  const response = await apiClient.get("/api/user");
  return response.data;
};

export const logout = async (): Promise<void> => {
  await apiClient.post("/api/account/logout");
};
